import ReducerRegistry from '../base/redux/ReducerRegistry';
import { TOGGLE_STRESS_CHECK_PANEL, START_STRESS_POLLING, STOP_STRESS_POLLING, UPDATE_STRESS_DATA, SET_STRESS_POLLING_ERROR } from './actionTypes';
const DEFAULT_STATE = {
    visible: false,
    polling: false,
    stressData: [],
    pollingInterval: 1000, // 1 second
    lastUpdated: null,
    error: null
};
/**
 * Reduces the Redux actions of the feature stress check.
 */
ReducerRegistry.register('features/stress-check', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case TOGGLE_STRESS_CHECK_PANEL:
            return {
                ...state,
                visible: !state.visible
            };
        case START_STRESS_POLLING:
            return {
                ...state,
                polling: true,
                error: null
            };
        case STOP_STRESS_POLLING:
            return {
                ...state,
                polling: false
            };
        case UPDATE_STRESS_DATA:
            return {
                ...state,
                stressData: action.payload,
                lastUpdated: Date.now(),
                error: null
            };
        case SET_STRESS_POLLING_ERROR:
            return {
                ...state,
                error: action.payload,
                polling: action.payload ? false : state.polling
            };
        default:
            return state;
    }
});
